import i18n from "lib/i18n";
import $ from "jquery";
import { defer, indexOf, template } from "lodash";
import { View } from "backbone";
import ButtonView from "views/button_view";
import Comment from "models/comment";
import Flash from "lib/flash";
import CommentEditorControlsView from "views/comment_editor_controls_view";
import CommentModeratorControlsView from "views/comment_moderator_controls_view";
import CommentRecommendsView from "views/comment_recommends_view";
import CommentBodyView from "views/comment_body_view";
import Minpubsub from "minpubsub";
import { currentUser } from "lib/currentUser";
import { wrapInUserModel } from "models/user";

/* eslint-disable
    camelcase,
    consistent-return,
    constructor-super,
    func-names,
    max-len,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentView;

export default CommentView = (function () {
  CommentView = class CommentView extends View {
    static initClass() {
      this.prototype.tagName = "li";
      this.prototype.className = "comment-view";

      // TODO: split user attribution into separate view
      this.prototype.template = template(`\
<article id="comment_<%- id %>" class="comment <%- user_type %>">
  <header class="meta">
    <section class="attribution author-avatar large">
      <img
        alt=""
        class="comment avatar rounded lazyload"
        data-src="<%- user_avatar_url %>"
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      >
      <h3 class="fn">
        <% if (user_profile_url) { %>
          <a href="<%- user_profile_url %>"><%- user_full_name %></a>
        <% } else { %>
          <%- user_full_name %>
        <% } %>
        <% if (user_friend_of_tc) { %>
          <a href="<%- custom_donation_url %>" class="friend-of-the-conversation-badge">
            <span>
              <div class="hover tooltip bottom">
                <%- i18n.t('comment.label.friend_of_the_conversation', { name: user_full_name }) %>
              </div>
            </span>
          </a>
        <% } %>
      </h3>
      <p>
        <% if (institution_name && institution_path) { %>
          <% if (user_occupation) { %>
            <%- user_occupation %>,
          <% } %>

          <a href="<%- institution_path %>"><%- institution_name %></a>
        <% } else { %>
          <%- user_occupation %>
        <% } %>
      </p>
    </section>
  </header>
  <% if (parent_id != undefined) { %>
    <section class="comment-in-reply-to">
      <%- i18n.t('comment.label.in_reply_to') %>
      <a class="comment-in-reply-to-link" href="#comment_<%- parent_id %>">
        <%- parent_user_full_name%>
      </a>
    </section>
  <% } %>
  <section class="comment-body">
    <div class="full-comment">
      <div class="more">
        <a class="comment-reference-link" href="#comment_<%- id %>">
          <time datetime="<%- created_at %>"><%- moment(created_at).fromNow() %></time>
        </a>
        <div class="comment-actions"></div>
      </div>
    </div>
  </section>
</article>
<ol class="comment-replies"></ol>\
`, { imports: { i18n } });

      this.prototype.removedCommentTemplate = template(`\
<article id="comment_<%- id %>">
  <p><%- i18n.t('comment.label.comment_removed_by_moderator') %></p>
</article>
<ol class="comment-replies"></ol>\
`, { imports: { i18n } });
    }

    async initialize(options) {
      super.initialize(options);

      this._recursiveRenderReplies = this._recursiveRenderReplies.bind(this);
      this._handleReply = this._handleReply.bind(this);

      this.renderNext = options.renderNext || (() => ({}));
      this.permissions = options.permissions;
      this.userRecommendedCommentIds = options.userRecommendedCommentIds;

      // TODO: rework this, messy
      if (options.comment) {
        this.model = new Comment(options.comment);
      }

      this._initCommentRecommendsView();

      // Unfortunately code further in this method relies on the dom from
      // rendering being present for it to work, so we have to wait for this render
      // to complete before continuing.
      await this.render();

      this.commentActionsEl = this.$el.find(".comment-actions");

      if (this.permissions.validate("_renderCommentRecommendsView")) { this._renderCommentRecommendsView(); }
      if (this.permissions.validate("_renderReplyButton")) { this._renderReplyButton(); }
      if (this.permissions.validate("_renderReportButton")) { this._renderReportButton(); }
      if (this.permissions.validate("_renderModeratorControls")) { this._renderModeratorControls(); }
      if (this.permissions.validate("_renderEditorControls")) { this._renderEditorControls(); }

      if (options.renderChildren) {
        this._renderReplies(this.model.get("children"));
      } else {
        this.renderNext();
      }

      this.model.on("comment:deleted", (message) => {
        Flash.now("notice", message);
        return this.$el.children(".comment").removeClass("pending").addClass("removed");
      });

      this.model.on("comment:deleted:failure", message =>
        // This message should probably come from the server and detail why
        Flash.now("alert", "Could not remove the comment, try again"),
      );

      this.model.on("comment:restored", (message) => {
        Flash.now("notice", message);
        return this.$el.children(".comment").removeClass("removed pending");
      });

      this.model.on("comment:restored:failure", message =>
        // This message should probably come from the server and detail why
        Flash.now("alert", "Could not restore the comment, try again"),
      );

      this.model.on("comment:removed", (message) => {
        Flash.now("notice", message);
        return this.$el.children(".comment").addClass("removed pending");
      });

      return this.model.on("comment:removed:failure", message => Flash.now("alert", message));
    }

    async render() {
      if (this.model.get("hidden")) {
        this.el.innerHTML = this.removedCommentTemplate(this.model.attributes);
      } else {
        const custom_donation_url = await this._donationUrl();
        const attributes = { custom_donation_url, ...this.model.attributes };

        this.el.innerHTML = this.template(attributes);
        this._renderCommentBodyView();
      }

      if (this.model.get("removed_at")) { this.$el.children(".comment").addClass("removed"); }
      if (this.model.get("removal_reason")) { return this.$el.children(".comment").addClass("pending"); }
    }

    renderFirstChildForTeaser() {
      const comments = this.model.get("children");
      if (comments.length === 0) { return false; }
      return this._renderReplies([comments[0]]);
    }

    _renderCommentBodyView() {
      this.commentBodyContainer = this.$el.find(".full-comment");
      this.commentBodyView = new CommentBodyView({ fullBody: this.model.get("full_body") });
      return this.commentBodyView.$el.prependTo(this.commentBodyContainer);
    }

    _renderCommentRecommendsView() {
      if (!this.model.get("hidden")) { return this.commentRecommendsView.$el.prependTo(this.$el); }
    }

    _renderReportButton() {
      const reportAbuseUrl = `${this.model.url()}/abuses/new`;
      return this.commentActionsEl.append($(`<a class="moderation-control report" title="${i18n.t("comment.button.report_comment")}" href="${reportAbuseUrl}">${i18n.t("comment.button.report")}</a>`));
    }

    _renderReplyButton() {
      this.replyButton = new ButtonView({
        label: i18n.t("comment.button.reply"),
        className: "button comment-reply",
      });
      this.replyButton.on("click", this._handleReply);
      return this.replyButton.$el.appendTo(this.$el.find(".more"));
    }

    _renderModeratorControls() {
      this.commentModeratorControlsView = new CommentModeratorControlsView({
        comment: this.model });

      this.commentModeratorControlsView.$el.appendTo(this.commentActionsEl);
      return this.commentModeratorControlsView.on("comment:remove", this.model.remove);
    }

    _renderEditorControls() {
      this.commentEditorControlsView = new CommentEditorControlsView({
        comment_user_id: this.model.get("user_id"),
        comment_user_email: this.model.get("user_email"),
      });

      this.commentEditorControlsView.$el.appendTo(this.commentActionsEl);
      this.commentEditorControlsView.on("comment:delete", this.model.delete);
      return this.commentEditorControlsView.on("comment:restore", this.model.restore);
    }

    _initCommentRecommendsView() {
      this.commentRecommendsView = new CommentRecommendsView({
        recommended: this._isRecommended(),
        highlyRecommended: this.model.get("highly_recommended"),
      });

      this.commentRecommendsView.on("comment:recommend", this.model.recommend);
      return this.commentRecommendsView.on("comment:unrecommend", this.model.unrecommend);
    }

    _isRecommended() {
      return indexOf(this.userRecommendedCommentIds, this.model.get("id")) !== -1;
    }

    _renderReplies(replies) {
      return this._recursiveRenderReplies(replies);
    }

    _recursiveRenderReplies(comments) {
      let renderNext;
      if (comments.length) {
        const comment = comments.shift();

        renderNext = () => defer(this._recursiveRenderReplies, comments);

        return new CommentView({
          comment,
          userRecommendedCommentIds: this.userRecommendedCommentIds,
          permissions: this.permissions,
          renderNext,
        }).$el.appendTo(this.$el.children(".comment-replies"));
      }
      return defer(this.renderNext);
    }

    _handleReply(event) {
      return Minpubsub.publish("comment:new", [this.model.get("id")]);
    }

    async _donationUrl() {
      const url = this.model.get("donation_url");
      const user = await currentUser().then(wrapInUserModel);

      if (user.exists()) {
        return `${url}&user_id=${user.get("id")}`;
      }
      return url;
    }
  };
  CommentView.initClass();
  return CommentView;
}());
